<template>
  <v-app>
    <vue-progress-bar>
    </vue-progress-bar>
    <alert-dialog
    :dialogText="alertBoxText"
    :dialog="alertBoxStatus"
    @onOk="triggerAlertOk"
    ></alert-dialog>
    <v-snackbar :bottom="true" :timeout="timeout" :color="mode" :value="snackbar" >
      {{ notice }}
      <v-btn dark flat @click.native="closeSnackbar">Close</v-btn>
    </v-snackbar>
    <template v-if="!loggedIn">
      <router-view></router-view>
    </template>
    <template v-else>
      <v-navigation-drawer width="250" light fixed v-model="drawer" app v-if="!profileMode"
      :clipped="$vuetify.breakpoint.lgAndUp">
        <v-list>
          <v-list-tile v-for="item in items" :key="item.title" @click="clickMenu(item)" router>
            <v-list-tile-action class="pr-1 pl-2 mr-1">
              <v-icon :class="activeMenuItem.includes(item.title)?'primary--text': ''" :title="item.title"  light v-html="item.icon"></v-icon>
            </v-list-tile-action>
            <v-list-tile-content :class="activeMenuItem.includes(item.title)?'primary--text': ''">
              <v-list-tile-title v-text="item.title"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <recommend-to-friend-tile></recommend-to-friend-tile>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      fixed
      dark
      color="primary"
      >
        <v-toolbar-side-icon @click.native.stop="drawer = !drawer" v-if="!profileMode"></v-toolbar-side-icon>
        <v-toolbar-title style="width:90px;height:75%">
          <v-img
          src="/static/img/tap_logo64x128.png"
          lazy-src="/static/img/tap_logo64x128.png"
          alt="tap logo"
          aspect-ratio="2"
          >
          </v-img>
        </v-toolbar-title>
        <span class="title text-uppercase font-weight-bold ml-3" v-show="!drawer">
          {{activeMenuItem}}
        </span>
        <v-spacer></v-spacer>
        <span class="title hidden-sm-and-down text-capitalize">
          {{user.firstName}} {{user.lastName}}
        </span>
        <v-toolbar-items>
          <v-menu bottom right offset-y origin="bottom" transition="v-slide-y-transition" class="hidden-sm-and-down">
            <v-btn flat slot="activator">
              <v-avatar>
                <img :src="avatarLink" alt="avatar">
              </v-avatar>
            </v-btn>
            <v-list>
              <v-list-tile v-for="item in userMenus" :key="item.title" value="true" :to="item.link" router>
                <v-list-tile-action>
                  <v-icon :title="item.title"  light v-html="item.icon"></v-icon>
                </v-list-tile-action>
                <v-list-tile-title v-text="item.title"></v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-menu bottom right offset-y origin="bottom right" transition="v-slide-y-transition" class="hidden-md-and-up">
            <v-btn icon slot="activator">
              <v-icon>more_vert</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile v-for="item in userMenus" :key="item.title" value="true" :to="item.link" router>
                <v-list-tile-title v-text="item.title"></v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-toolbar>
      <v-content>
        <v-container fluid fill-height>
          <v-layout>
            <v-flex row="">
              <router-view></router-view>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
      <!-- <canvas id="canvas"></canvas> -->
      <v-footer fixed style="justify-content:space-around; text-align: center" app>
        <span class="primary--text">&copy; Theseus Technologies Pvt. Ltd. 2018</span>
        <span class="primary--text">support: reach@ordertrainings.com</span>
      </v-footer>
    </template>
  </v-app>
</template>
<script>
/* globals Store, Router */
import auth from './utils/auth'
import RecommendToFriendTile from '@/components/RecommendToFriendTile'
import AlertDialog from '@/components/AlertDialog'
import { mapState } from 'vuex'
import {
  sendWarningNotice,
  closeNotice
} from '@/utils/store-util.js'
export default {
  components: {
    RecommendToFriendTile,
    AlertDialog
  },
  data () {
    return {
      dialog: false,
      timeout: 20000,
      dialogText: '',
      dialogTitle: '',
      isRootComponent: true,
      loggedIn: auth.loggedIn(),
      profileMode: auth.profileMode(),
      // clipped: false,
      drawer: null,
      fixed: false,
      items: [
        {
          icon: 'dashboard',
          title: 'Dashboard',
          link: 'dashboard'
        },
        {
          icon: 'assignment',
          title: 'Profile',
          link: 'profile'
        },
        {
          icon: 'work',
          title: 'Packages',
          link: 'packages'
        },
        {
          icon: 'date_range',
          title: 'Calendar',
          link: 'calendar'
        },
        {
          icon: 'person',
          title: 'Account',
          link: 'account'
        },
        {
          icon: 'help',
          title: 'Help',
          link: 'help'
        }
      ],
      right: true,
      rightDrawer: false,
      menuItem: Router.currentRoute.name
    }
  },
  created () {
    auth.onChange = (loggedIn, profileMode) => {
      this.drawer = !profileMode
      if (!this.profileMode && profileMode) {
        sendWarningNotice(null, 'Your profile information is not enough to access dashboard. Please go through the profile completion flow.')
        closeNotice(null, 20000)
      }
      this.profileMode = profileMode
      this.loggedIn = loggedIn
    }
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start()
    //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress
        // parse meta tags
        this.$Progress.parseMeta(meta)
      }
      //  start the progress bar
      this.$Progress.start()
      //  continue to next page
      next()
    })
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach((to, from) => {
      if (to.name !== 'ErrorPage') {
        this.menuItem = to.name
      }
      //  finish the progress bar
      this.$Progress.finish()
    })
  },
  computed: {
    userMenus () {
      if (!this.profileMode) {
        return [
          {
            icon: 'person',
            title: 'Account',
            link: 'account'
          },
          {
            icon: 'exit_to_app',
            title: 'Logout',
            link: '/logout'
          }
        ]
      } else {
        return [
          {
            icon: 'exit_to_app',
            title: 'Logout',
            link: '/logout'
          }
        ]
      }
    },
    ...mapState('user', {
      user: 'user',
      completion: 'completion'
    }),
    ...mapState('project', {
      loading: 'loading',
      mode: 'mode',
      snackbar: 'snackbar',
      notice: 'notice',
      alertBoxText: 'alertBoxText',
      alertBoxStatus: 'alertBoxStatus'
    }),
    auth () {
      return auth
    },
    activeMenuItem () {
      return this.menuItem
    },
    avatarLink () {
      return '/static/img/' + this.user.gender + '.png'
    }
  },
  methods: {
    triggerAlertOk () {
      Store.dispatch('project/manageAlertBox', { status: false, text: '' })
      if (this.loggedIn) {
        Router.push('/logout')
      } else {
        Router.push('/login')
      }
    },
    closeSnackbar () {
      Store.dispatch('project/closeNotice')
    },
    clickMenu (item) {
      this.menuItem = item.title
      this.$router.push({
        name: item.title
      })
    }
  },
  mounted () {
    this.$Progress.finish()
  }
}
</script>
<style lang='stylus'>
@import './stylus/main'
</style>



// WEBPACK FOOTER //
// src/App.vue